import Vue from 'vue';

const END_POINT = '/contact-type';

const getContactType = (id) => Vue.axios.get(END_POINT + '/' + id);

const getAllContactTypes = (data) => Vue.axios.get(END_POINT, { params: data });

const createContactType = (contactType) =>
  Vue.axios.post(END_POINT, contactType);

const createAllContactTypes = (ContactTypes) =>
  Vue.axios.post(END_POINT + '/all', ContactTypes);

const updateContactType = (contactType) =>
  Vue.axios.put(END_POINT + '/' + contactType.id, contactType);

const deleteContactType = (id) => Vue.axios.delete(END_POINT + '/' + id);

export {
  getContactType,
  getAllContactTypes,
  createContactType,
  createAllContactTypes,
  updateContactType,
  deleteContactType,
};
